<template>

  <div class="page">

    <div class="top"></div>

    <div class="back" @click="back"></div>

    <div class="container" v-show="!clear">
  
      <div class="scroll">
        <img src="../../../images/index/prize-content.png" width="100%"/>
      </div>

    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      clear: false
    };
  },
  components: {},
  mounted() {},
  methods: {
    back() {
      this.$emit("back");
    },
    onClear(e) {
      this.clear = e;
    },
    onClose() {
      this.clear = false;
    },
  },
};
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  background: url("../../../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
}
.top {
  z-index: 2;
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 209px;
  background: url("../../../images/title-prize.png") no-repeat;
  background-size: 100%;
}
.back {
  position: absolute;
  z-index: 2;
  left: 50px;
  bottom: 70%;
  width: 342px;
  height: 126px;
  background: url("../../../images/btn-back.png") no-repeat;
  background-size: 100%;
}
.container {
  position: absolute;
  left: 0;
  right: 0;
  // bottom: 224px;
  bottom: 4%;
  margin: 0 auto;
  overflow-y: scroll;
  height: 1000px;
  width: 100%;
  text-align: center;
  .scroll {
    width: 551px;
    height: 1526px;
    text-align: center;
    padding-top: 50px;
    margin: 0 auto;
  }
}
</style>
